<!-- category-grid.component.html -->

<table class="table table-striped table-bordered">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Category Name</th>
        <th scope="col">Category Description</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of category">
        <td>{{ item.categoryName }}</td>
        <td>{{ item.categoryDescp }}</td>
        <td>
          <button class="btn btn-warning btn-sm" (click)="onEdit(item)">Edit</button>
          <button class="btn btn-danger btn-sm" (click)="onDelete(item.categoryId)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
